export function formatCssUnit(value: number | string) {
	return typeof value === 'string' ? value : `${value}px`;
}
